import { FlagPatternBox } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/FlagPatternBox';
import { FlagTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/FlagTacticPanel';
import { FlagWrapper } from '../../../../components/displays/tradeplans/softOrderModules/setupModules/FlagModule/wrapper/FlagWrapper';
import FlagDoc from '../../../../components/forms/tradeplans/documentation/FlagDoc';
import { FlagData } from './flagData';
import { validateFlag } from './validateFlag';

export const Flag = {
  //data class
  dataStore: FlagData,

  //string constants
  name: 'FLAG',
  tacticLabel: 'Flag',
  addTacticLabel: 'Add Flag',
  category: 'Setup',

  //components
  tradePlanFormModule: null,
  tacticPanel: FlagTacticPanel,
  addTacticPanel: null,
  wrapper: FlagWrapper,
  chartSoftOrderComponent: FlagPatternBox,
  documentation: FlagDoc,
  alertDetailsComponent: null, //todo

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateFlag,
};
